module.exports = __webpack_public_path__ + "static/media/demisuite3.bb12f93f.jpg";